import { stenaFinanceUnpaid } from "@stenajs-webui/elements";
import * as React from "react";
import { useFilterWorkspace } from "../../hooks/UseFilterWorkspace";
import { RangeFilter } from "../../types/RangeFilter";
import { FppSearchFilterSection } from "../FppSearchFilterSection";
import { RangeControl } from "../RangeControl";

interface Props {
  enabled?: boolean;
  label?: string;
  labelFrom?: string;
  labelTo?: string;
  maxDecimals?: number;
  maxNumbers?: number;
}

export const AverageNetPriceFilterSection: React.FC<Props> = ({
  enabled,
  label,
  labelFrom,
  labelTo,
  maxDecimals,
  maxNumbers,
}) => {
  const { averageNetPrice, setAverageNetPrice } = useFilterWorkspace();

  const onFilterValueChange = (rangeFilter: RangeFilter) => {
    setAverageNetPrice({ ...rangeFilter });
  };

  const numberOfActiveFilters = () => {
    return averageNetPrice.from || averageNetPrice.to ? 1 : 0;
  };

  return (
    <FppSearchFilterSection
      sectionId={"averageNetPrice"}
      label={label}
      enabled={enabled}
      numSelected={numberOfActiveFilters()}
      leftIcon={stenaFinanceUnpaid}
      children={
        <RangeControl<RangeFilter>
          value={averageNetPrice}
          valueFrom={averageNetPrice.from}
          valueTo={averageNetPrice.to}
          onValueChange={onFilterValueChange}
          labelFrom={labelFrom ?? "From"}
          labelTo={labelTo ?? "To"}
          maxNumbers={maxNumbers}
          maxDecimals={maxDecimals}
        />
      }
    />
  );
};
